import { action } from 'easy-peasy';
import { IActionAddCarePlanHospitalization } from '../types';

const addCarePlanHospitalization: IActionAddCarePlanHospitalization = action((state, payload) => {
  state.items = [payload, ...state.items].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
  );
});

export default addCarePlanHospitalization;
